import * as envalid from "envalid";

const { num, str, bool } = envalid;

export default envalid.cleanEnv(process.env, {
  PORT: num({
    default: 5000,
  }),
  REACT_APP_LISTINGS_API_URL: str(),
  REACT_APP_PARCELS_API_SERVER_URL: str(),
  REACT_APP_BLOG_API: str(),
  REACT_APP_BLOG_ACCESS_TOKEN: str(),
  REACT_APP_SOIL_API_SERVER_URL: str(),
  REACT_APP_DTN_CLUS_URL: str(),
  REACT_APP_DTN_SOIL_URL: str(),
  REACT_APP_SERVER_API_URL: str({
    default: "http://localhost:4444",
  }),
  REACT_APP_DOMAIN: str({
    default: "http://localhost:3005",
  }),
  REACT_APP_SOCKET_SERVER: str({
    default: "ws://localhost:3002",
  }),
  REACT_APP_ALLIANCE_PARTNER_DASHBOARD: bool({
    default: false,
  }),
  REACT_APP_STANDALONE_DOMAIN: str(),
  REACT_APP_CG_STANDALONE_DOMAIN: str(),
  REACT_APP_CLIENT_ID: str(),
  REACT_APP_CLIENT_SECRET: str(),
  REACT_APP_CLIENT_GRANT_TYPE: str(),
  REACT_APP_PARCEL_KEY_REPORT_ALL: str(),
  REACT_APP_CHAT_SUPPORT_AVAILABLE: bool({
    default: true,
  }),
  REACT_APP_GMAP_KEY: str(),
  REACT_APP_RECAPTCHA_KEY: str(),
  REACT_APP_RECAPTCHA_SECRET: str(),
  REACT_APP_FIREBASE_API_KEY: str(),
  REACT_APP_FIREBASE_AUTH_DOMAIN: str(),
  REACT_APP_FIREBASE_PROJECT_ID: str(),
  REACT_APP_FIREBASE_STORAGE_BUCKET: str(),
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID: str(),
  REACT_APP_FIREBASE_APP_ID: str(),
  REACT_APP_FIREBASE_MEASUREMENT_ID: str(),
  REACT_APP_SOILMAP_API_KEY: str(),
  REACT_APP_TYPEFORM_INSURANCE_URL: str(),
  REACT_APP_STRIPE_PUBLIC_KEY: str(),
  REACT_APP_SERVERLESS_UPLOAD_URL: str(),
  REACT_APP_PUSHER_APP_CLUSTER: str(),
  REACT_APP_PUSHER_APP_KEY: str(),
  REACT_APP_SEGMENT_KEY: str(),
}, {
  dotEnvPath: null,
});
